(function () {
  /**
   * @ngdoc directive
   * @name appHideWithFeature
   * @description
   * Feature markup directly within views without requiring controller support.
   * Element removed if hideWithFeature flag is enabled.
   * For example: <p app-hide-with-feature="enabledFlag">Hide this paragraph.</p>
   */
  angular.module('app.widgets.common.feature').directive('appHideWithFeature', hideWithFeature);

  function hideWithFeature(feature) {
    return {
      link: (scope, element, attrs) => {
        if (feature.isEnabled(attrs.appHideWithFeature)) {
          element.remove();
        }
      },
      restrict: 'A',
    };
  }
})();
